<template>
  <div class="frisbuy-guideline" @click.stop>
    <div ref="guidelineScrollWrapper" class="fb-guideline-container">
      <svg
        class="fb-guideline-btn-close"
        width="58"
        height="58"
        viewBox="0 0 58 58"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click.stop="$emit('toggle-guide')"
      >
        <circle cx="29" cy="29" r="29" fill="black" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M32.5355 28.9998L40.4343 21.1011L36.8988 17.5656L29 25.4643L21.1012 17.5656L17.5657 21.1011L25.4645 28.9998L17.5654 36.8989L21.101 40.4344L29 32.5354L36.899 40.4344L40.4346 36.8989L32.5355 28.9998Z"
          fill="white"
        />
      </svg>
      <div v-html="html_guideline_block" />
    </div>
  </div>
</template>

<script>
export default {
  props: ["html_guideline_block"],
};
</script>

<style>
.frisbuy-guideline {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 99999999999999;
  background-color: white;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
</style>
